<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF AMEND CHANGES</b></h5>
    <hr />
    <TableStockoutChangesIndex :fields="fields.fields" :items="items" />
  </b-card>
</template>

<script>
import TableStockoutChangesIndex from "@/table/user/stockoutChanges/TableStockoutChangesIndex";

export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Type",
            key: "type",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Status",
            key: "status",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    this.getSC();
  },
  methods: {
    getSC() {
      this.$store.dispatch("getSC", 5).then(res => {
        let no = 0;
        res.data.data.forEach(element => {
          no = no + 1;
          // let type = element.type === 1 ? "UHT" : "Pasteurized";
          this.items.push({
            no: no,
            type: element.category,
            date: element.date_request,
            status: element.status,
            id: element.amend_changes_id
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableStockoutChangesIndex
  }
};
</script>
<style lang="css" scoped></style>
